import { Link } from "@tanstack/react-router";

import type { Block } from "@/lib/content";

/**
 * Renders migrated page content blocks with the site's typographic system.
 * Headings use Oswald, body copy uses Nunito Sans (see styles.css).
 */
export function PageBlocks({ blocks }: { blocks: Block[] }) {
  return (
    <div className="flex flex-col gap-5">
      {blocks.map((block, i) => {
        if (block.t === "img") {
          return (
            <img
              key={i}
              src={block.src}
              alt={block.alt ?? ""}
              loading="lazy"
              decoding="async"
              className="w-full rounded-lg object-cover"
            />
          );
        }
        if (block.t === "a") {
          const external = /^https?:/.test(block.href) || block.href.startsWith("mailto:");
          return external ? (
            <a
              key={i}
              href={block.href}
              className="font-heading text-sm uppercase tracking-widest text-brand-foreground underline decoration-brand decoration-2 underline-offset-4"
            >
              {block.text}
            </a>
          ) : (
            <Link
              key={i}
              to={block.href}
              className="font-heading text-sm uppercase tracking-widest text-brand-foreground underline decoration-brand decoration-2 underline-offset-4"
            >
              {block.text}
            </Link>
          );
        }
        if (block.t === "h1") {
          return (
            <h2 key={i} className="mt-8 text-4xl text-navy">
              {block.text}
            </h2>
          );
        }
        if (block.t === "h2") {
          return (
            <h2 key={i} className="mt-8 text-3xl text-navy">
              {block.text}
            </h2>
          );
        }
        if (block.t === "h3" || block.t === "h4") {
          return (
            <h3 key={i} className="mt-4 text-xl text-navy">
              {block.text}
            </h3>
          );
        }
        if (block.t === "li") {
          return (
            <p key={i} className="text-foreground">
              {block.text}
            </p>
          );
        }
        return (
          <p key={i} className="text-foreground">
            {block.text}
          </p>
        );
      })}
    </div>
  );
}
